export const TILE_ACTION_DATA_VIDEO_INLINE = 'video_inline';
// this is null for legacy reasons. At some point we might want to update the code to use a value like 'overlay' instead.
export const TILE_ACTION_DATA_OVERLAY = null; 

export const TILE_ACTION_INDICATOR_DEFAULT = 'default';
export const TILE_ACTION_INDICATOR_CUSTOM = 'custom';
